import React from "react";
export const FullRow = ({ children, showFirstColumn, noHover }) => {
  const colSpan = showFirstColumn ? 6 : 7;
  return (
    <tr className={noHover ? "no-hover" : ""}>
      {showFirstColumn && <td>&nbsp;</td>}
      <td colSpan={colSpan} style={{ padding: 0 }}>
        {children}
      </td>
    </tr>
  );
};
